import request from './request'
import * as http from '@/libs/http'

/**
 * 店舗の車両一覧を取得する
 *
 * @param {Number} shopid 店舗ID
 * @param {Array} fields 追加フィールド
 * @returns {Response} レスポンスデータ
 */
export function getShopCars (shopid, fields = []) {
  return request.get(`/shops/${shopid}/cars`, {
    params: {
      fields: [
        'id',
        ...fields
      ]
    },
    validateStatus: (status) => [
      http.OK,
      http.NoContent
    ].includes(status)
  })
}
